export const PDF_THEME = {
	primaryColor: '#c8d6e6',
	secondaryColor: '#203e60',
	ternaryColor: '#edf4ff',
}
